var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm.dialogErrTxt
      ? _c("div", { staticClass: "alert alert-danger" }, [
          _vm._v(" " + _vm._s(_vm.dialogErrTxt) + " ")
        ])
      : _vm._e(),
    _vm.dialogOkTxt
      ? _c("div", { staticClass: "alert alert-success" }, [
          _vm._v(" " + _vm._s(_vm.dialogOkTxt) + " ")
        ])
      : _vm._e(),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "d-flex flex-row w-100 mb-2" }, [
          _c("h4", { staticClass: "flex-grow-1 mb-0" }, [
            _vm._v(" Informations de facturation ")
          ]),
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-primary",
              attrs: { type: "button" },
              on: { click: _vm.showInvoiceAddrDialog }
            },
            [_vm._v(" Modifier ")]
          )
        ]),
        _c("div", { staticClass: "alert alert-light position-relative mb-1" }, [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.row_co.co_invoice_civility,
                  expression: "row_co.co_invoice_civility "
                }
              ]
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.getCivility(_vm.row_co.co_invoice_civility)) +
                  "  "
              )
            ]
          ),
          _vm._v(
            " " +
              _vm._s(_vm.row_co.co_invoice_firstname) +
              " " +
              _vm._s(_vm.row_co.co_invoice_name)
          ),
          _c("br"),
          _c("div", { staticClass: "mt-2" }, [
            _vm._v(" " + _vm._s(_vm.row_co.co_invoice_address1) + " "),
            _c("br"),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.row_co.co_invoice_address2,
                    expression: "row_co.co_invoice_address2"
                  }
                ]
              },
              [
                _vm._v(" " + _vm._s(_vm.row_co.co_invoice_address2) + " "),
                _c("br")
              ]
            ),
            _vm._v(
              " " +
                _vm._s(_vm.row_co.co_invoice_zip) +
                " " +
                _vm._s(_vm.row_co.co_invoice_city) +
                " "
            ),
            _c("br"),
            _vm._v(
              " " + _vm._s(_vm.getCountry(_vm.row_co.co_invoice_country)) + " "
            )
          ]),
          _c("div", { staticClass: "mt-2" }, [
            _c("label", [_vm._v("email : ")]),
            _vm._v(" " + _vm._s(_vm.row_co.co_invoice_email)),
            _c("br"),
            _c("label", [_vm._v("téléphone : ")]),
            _vm._v(" " + _vm._s(_vm.row_co.co_invoice_tel) + " ")
          ])
        ])
      ]),
      _c("div", [
        _c("div", { staticClass: "form-check form-switch mb-3" }, [
          _c("input", {
            staticClass: "form-check-input",
            attrs: {
              type: "checkbox",
              role: "switch",
              id: "co_adresses_different"
            },
            domProps: { checked: _vm.areAdressesIdentical },
            on: { change: _vm.copyInvoiceToShippingAddr }
          }),
          _c(
            "label",
            {
              staticClass: "form-check-label",
              attrs: { for: "co_adresses_different" }
            },
            [_vm._v(" Adresse de livraison identique à celle de facturation ")]
          )
        ])
      ])
    ]),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "d-flex flex-row w-100 mb-2" }, [
          _c("h4", { staticClass: "flex-grow-1 mb-0" }, [
            _vm._v(" Informations de livraison ")
          ]),
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-primary",
              attrs: {
                type: "button",
                disabled: !_vm.row_co.co_adresses_different
              },
              on: { click: _vm.showShippingAddrDialog }
            },
            [_vm._v(" Modifier ")]
          )
        ]),
        _c("div", { staticClass: "alert alert-light position-relative" }, [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.row_co.co_shipping_civility,
                  expression: "row_co.co_shipping_civility"
                }
              ]
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.getCivility(_vm.row_co.co_shipping_civility)) +
                  "  "
              )
            ]
          ),
          _vm._v(
            " " +
              _vm._s(_vm.row_co.co_shipping_firstname) +
              " " +
              _vm._s(_vm.row_co.co_shipping_name)
          ),
          _c("br"),
          _c("div", { staticClass: "mt-2" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.row_co.co_shipping_society_name,
                    expression: "row_co.co_shipping_society_name"
                  }
                ]
              },
              [_vm._v(" " + _vm._s(_vm.row_co.co_shipping_society_name) + " ")]
            ),
            _vm._v(" " + _vm._s(_vm.row_co.co_shipping_address1) + " "),
            _c("br"),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.row_co.co_shipping_address2,
                    expression: "row_co.co_shipping_address2"
                  }
                ]
              },
              [
                _vm._v(" " + _vm._s(_vm.row_co.co_shipping_address2) + " "),
                _c("br")
              ]
            ),
            _vm._v(
              " " +
                _vm._s(_vm.row_co.co_shipping_zip) +
                " " +
                _vm._s(_vm.row_co.co_shipping_city) +
                " "
            ),
            _c("br"),
            _vm._v(
              " " + _vm._s(_vm.getCountry(_vm.row_co.co_shipping_country)) + " "
            )
          ]),
          _c("div", { staticClass: "mt-2" }, [
            _c("label", [_vm._v("téléphone : ")]),
            _vm._v(" " + _vm._s(_vm.row_co.co_shipping_tel) + " ")
          ])
        ])
      ])
    ]),
    _c(
      "div",
      {
        ref: "modalUpdateInvoiceAddr",
        class: _vm.dialogInvoiceAddr.display ? "modal fade show" : "modal fade",
        style: _vm.dialogInvoiceAddr.display ? "display:block" : "display:none",
        attrs: { tabindex: "-1", role: "dialog" }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-dialog-centered",
            attrs: { role: "document" }
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("form", { attrs: { id: "paymentForm" } }, [
                _vm._m(0),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-2 g-2" }, [
                      _c("label", { attrs: { for: "co_invoice_civility" } }, [
                        _vm._v("Civilité")
                      ]),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.row_co.co_invoice_civility,
                              expression: "row_co.co_invoice_civility"
                            }
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.row_co,
                                "co_invoice_civility",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        _vm._l(_vm.$store.state.items_civility, function(
                          option,
                          indexOption
                        ) {
                          return _c(
                            "option",
                            {
                              key: indexOption,
                              domProps: { value: option.value }
                            },
                            [_vm._v(_vm._s(option.text))]
                          )
                        }),
                        0
                      )
                    ]),
                    _c("div", { staticClass: "col-5 g-2" }, [
                      _c("label", { attrs: { for: "co_invoice_firstname" } }, [
                        _vm._v("Prénom")
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.row_co.co_invoice_firstname,
                            expression: "row_co.co_invoice_firstname"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.row_co.co_invoice_firstname },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.row_co,
                              "co_invoice_firstname",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _c("div", { staticClass: "col-5 g-2" }, [
                      _c("label", { attrs: { for: "co_invoice_name" } }, [
                        _vm._v("Nom")
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.row_co.co_invoice_name,
                            expression: "row_co.co_invoice_name"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.row_co.co_invoice_name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.row_co,
                              "co_invoice_name",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-6 g-2" }, [
                      _c("label", { attrs: { for: "co_login" } }, [
                        _vm._v("Email")
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.row_co.co_invoice_email,
                            expression: "row_co.co_invoice_email"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.row_co.co_invoice_email },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.row_co,
                                "co_invoice_email",
                                $event.target.value
                              )
                            },
                            _vm.fillLoginInput
                          ]
                        }
                      })
                    ]),
                    _c("div", { staticClass: "col-6 g-2" }, [
                      _c("label", { attrs: { for: "co_invoice_tel" } }, [
                        _vm._v("Téléphone")
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.row_co.co_invoice_tel,
                            expression: "row_co.co_invoice_tel"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.row_co.co_invoice_tel },
                        on: {
                          change: function($event) {
                            return _vm.checkPhone(
                              $event.target.value,
                              "co_invoice_tel"
                            )
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.row_co,
                              "co_invoice_tel",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 g-2" }, [
                      _c("label", { attrs: { for: "co_invoice_tel" } }, [
                        _vm._v("Adresse")
                      ]),
                      _c("div", { staticClass: "position-relative" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.row_co.co_invoice_address1,
                              expression: "row_co.co_invoice_address1"
                            }
                          ],
                          ref: "address_research_invoice",
                          staticClass: "form-control",
                          attrs: { type: "text", placeholder: "Adresse" },
                          domProps: { value: _vm.row_co.co_invoice_address1 },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.row_co,
                                  "co_invoice_address1",
                                  $event.target.value
                                )
                              },
                              function($event) {
                                return _vm.checkAddress("invoice")
                              }
                            ]
                          }
                        }),
                        _vm.addressesList1
                          ? _c(
                              "div",
                              { staticClass: "addresses-list" },
                              [
                                _vm._l(_vm.addresses1, function(address) {
                                  return _c(
                                    "div",
                                    {
                                      key: address.id,
                                      on: {
                                        click: function($event) {
                                          return _vm.applyAddress(
                                            address,
                                            "invoice"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(" " + _vm._s(address.label) + " ")]
                                  )
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-end text-right",
                                    on: {
                                      click: function($event) {
                                        return _vm.closeAddress("invoice")
                                      }
                                    }
                                  },
                                  [
                                    _c("icon", { attrs: { name: "times" } }),
                                    _vm._v(" Fermer ")
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 g-2" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.row_co.co_invoice_address2,
                            expression: "row_co.co_invoice_address2"
                          }
                        ],
                        staticClass: "form-control mb-2",
                        attrs: {
                          type: "text",
                          placeholder: "Complément d'adresse"
                        },
                        domProps: { value: _vm.row_co.co_invoice_address2 },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.row_co,
                              "co_invoice_address2",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-6 g-2" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.row_co.co_invoice_zip,
                            expression: "row_co.co_invoice_zip"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", placeholder: "Code postal" },
                        domProps: { value: _vm.row_co.co_invoice_zip },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.row_co,
                              "co_invoice_zip",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _c("div", { staticClass: "col-6 g-2" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.row_co.co_invoice_city,
                            expression: "row_co.co_invoice_city"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", placeholder: "Ville" },
                        domProps: { value: _vm.row_co.co_invoice_city },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.row_co,
                              "co_invoice_city",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-6 g-2" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.row_co.co_invoice_country,
                              expression: "row_co.co_invoice_country"
                            }
                          ],
                          staticClass: "form-control mb-2",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.row_co,
                                "co_invoice_country",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        _vm._l(_vm.$store.state.items_countries, function(
                          option,
                          indexOption
                        ) {
                          return _c(
                            "option",
                            {
                              key: indexOption,
                              domProps: { value: option.value }
                            },
                            [_vm._v(" " + _vm._s(option.text) + " ")]
                          )
                        }),
                        0
                      )
                    ]),
                    _c("div", { staticClass: "col-6 g-2" })
                  ])
                ]),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: {
                        type: "button",
                        disabled: _vm.dialogInvoiceAddr.processing
                      },
                      on: {
                        click: function($event) {
                          return _vm.closeInvoiceAddrDialog()
                        }
                      }
                    },
                    [_vm._v(" Annuler ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        type: "button",
                        disabled: _vm.dialogInvoiceAddr.processing
                      },
                      on: {
                        click: function($event) {
                          return _vm.saveInvoiceAddrDialog()
                        }
                      }
                    },
                    [
                      _vm.dialogInvoiceAddr.processing
                        ? _c("Icon", {
                            attrs: {
                              name: "hourglass-half",
                              fill: "white",
                              spin: ""
                            }
                          })
                        : _vm._e(),
                      _vm._v(" Sauvegarder ")
                    ],
                    1
                  )
                ])
              ])
            ])
          ]
        )
      ]
    ),
    _c(
      "div",
      {
        ref: "modalUpdateShippingAddr",
        class: _vm.dialogShippingAddr.display
          ? "modal fade show"
          : "modal fade",
        style: _vm.dialogShippingAddr.display
          ? "display:block"
          : "display:none",
        attrs: { tabindex: "-1", role: "dialog" }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-dialog-centered",
            attrs: { role: "document" }
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("form", { attrs: { id: "paymentForm" } }, [
                _vm._m(1),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-2 g-2" }, [
                      _c("label", { attrs: { for: "co_shipping_civility" } }, [
                        _vm._v("Civilité")
                      ]),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.row_co.co_shipping_civility,
                              expression: "row_co.co_shipping_civility"
                            }
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.row_co,
                                "co_shipping_civility",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        _vm._l(_vm.$store.state.items_civility, function(
                          option,
                          indexOption
                        ) {
                          return _c(
                            "option",
                            {
                              key: indexOption,
                              domProps: { value: option.value }
                            },
                            [_vm._v(_vm._s(option.text))]
                          )
                        }),
                        0
                      )
                    ]),
                    _c("div", { staticClass: "col-5 g-2" }, [
                      _c("label", { attrs: { for: "co_shipping_firstname" } }, [
                        _vm._v("Prénom")
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.row_co.co_shipping_firstname,
                            expression: "row_co.co_shipping_firstname"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.row_co.co_shipping_firstname },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.row_co,
                              "co_shipping_firstname",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _c("div", { staticClass: "col-5 g-2" }, [
                      _c("label", { attrs: { for: "co_shipping_name" } }, [
                        _vm._v("Nom")
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.row_co.co_shipping_name,
                            expression: "row_co.co_shipping_name"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.row_co.co_shipping_name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.row_co,
                              "co_shipping_name",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-6 g-2" }, [
                      _c(
                        "label",
                        { attrs: { for: "co_shipping_society_name" } },
                        [_vm._v("Société")]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.row_co.co_shipping_society_name,
                            expression: "row_co.co_shipping_society_name"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: {
                          value: _vm.row_co.co_shipping_society_name
                        },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.row_co,
                              "co_shipping_society_name",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _c("div", { staticClass: "col-6 g-2" }, [
                      _c("label", { attrs: { for: "co_shipping_tel" } }, [
                        _vm._v("Téléphone")
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.row_co.co_shipping_tel,
                            expression: "row_co.co_shipping_tel"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.row_co.co_shipping_tel },
                        on: {
                          change: function($event) {
                            return _vm.checkPhone(
                              $event.target.value,
                              "co_shipping_tel"
                            )
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.row_co,
                              "co_shipping_tel",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 g-2" }, [
                      _c("label", [_vm._v("Adresse")]),
                      _c("div", { staticClass: "position-relative" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.row_co.co_shipping_address1,
                              expression: "row_co.co_shipping_address1"
                            }
                          ],
                          ref: "address_research_shipping",
                          staticClass: "form-control",
                          attrs: { type: "text", placeholder: "Adresse" },
                          domProps: { value: _vm.row_co.co_shipping_address1 },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.row_co,
                                  "co_shipping_address1",
                                  $event.target.value
                                )
                              },
                              function($event) {
                                return _vm.checkAddress("shipping")
                              }
                            ]
                          }
                        }),
                        _vm.addressesList2
                          ? _c(
                              "div",
                              { staticClass: "addresses-list" },
                              [
                                _vm._l(_vm.addresses2, function(address) {
                                  return _c(
                                    "div",
                                    {
                                      key: address.id,
                                      on: {
                                        click: function($event) {
                                          return _vm.applyAddress(
                                            address,
                                            "shipping"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(" " + _vm._s(address.label) + " ")]
                                  )
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-end text-right",
                                    on: {
                                      click: function($event) {
                                        return _vm.closeAddress("invoice")
                                      }
                                    }
                                  },
                                  [
                                    _c("icon", { attrs: { name: "times" } }),
                                    _vm._v(" Fermer ")
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 g-2" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.row_co.co_shipping_address2,
                            expression: "row_co.co_shipping_address2"
                          }
                        ],
                        staticClass: "form-control mb-2",
                        attrs: {
                          type: "text",
                          placeholder: "Complément d'adresse"
                        },
                        domProps: { value: _vm.row_co.co_shipping_address2 },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.row_co,
                              "co_shipping_address2",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-6 g-2" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.row_co.co_shipping_zip,
                            expression: "row_co.co_shipping_zip"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", placeholder: "Code postal" },
                        domProps: { value: _vm.row_co.co_shipping_zip },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.row_co,
                              "co_shipping_zip",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _c("div", { staticClass: "col-6 g-2" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.row_co.co_shipping_city,
                            expression: "row_co.co_shipping_city"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", placeholder: "Ville" },
                        domProps: { value: _vm.row_co.co_shipping_city },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.row_co,
                              "co_shipping_city",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-6 g-2" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.row_co.co_shipping_country,
                              expression: "row_co.co_shipping_country"
                            }
                          ],
                          staticClass: "form-control mb-2",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.row_co,
                                "co_shipping_country",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        _vm._l(_vm.$store.state.items_countries, function(
                          option,
                          indexOption
                        ) {
                          return _c(
                            "option",
                            {
                              key: indexOption,
                              domProps: { value: option.value }
                            },
                            [_vm._v(" " + _vm._s(option.text) + " ")]
                          )
                        }),
                        0
                      )
                    ]),
                    _c("div", { staticClass: "col-6 g-2" })
                  ])
                ]),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: {
                        type: "button",
                        disabled: _vm.dialogShippingAddr.processing
                      },
                      on: {
                        click: function($event) {
                          return _vm.closeShippingAddrDialog()
                        }
                      }
                    },
                    [_vm._v(" Annuler ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        type: "button",
                        disabled: _vm.dialogShippingAddr.processing
                      },
                      on: {
                        click: function($event) {
                          return _vm.saveShippingAddrDialog()
                        }
                      }
                    },
                    [
                      _vm.dialogShippingAddr.processing
                        ? _c("Icon", {
                            attrs: {
                              name: "hourglass-half",
                              fill: "white",
                              spin: ""
                            }
                          })
                        : _vm._e(),
                      _vm._v(" Sauvegarder ")
                    ],
                    1
                  )
                ])
              ])
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [
        _vm._v("Informations de facturation")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [
        _vm._v("Informations de livraison")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }